<app-navbar></app-navbar>
<div class="container py-3">
	<h3>FEA Applications Review</h3>

	<div *ngIf="loading">Loading applications...</div>

	<table *ngIf="!loading" class="table table-striped">
		<thead>
			<tr>
				<th>#</th>
				<th>Name</th>
				<th>Email</th>
                <th>Phone</th>
                <th>City</th>
				<th>Submitted</th>
				<th>Status</th>
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let app of applications; let i = index">
				<td>{{ i + 1 }}</td>
				<td>{{ app.fullName }}</td>
				<td>{{ app.email }}</td>
                <td>{{ app.phone }}</td>
                <td>{{ app.city }}</td>
				<td>{{ app.createdAt?.toDate ? (app.createdAt.toDate() | date:'short') : (app.createdAt | date:'short') }}</td>
				<td>{{ app.status || 'pending' }}</td>
				<td>
					<button class="btn btn-sm btn-primary me-2" (click)="openReview(app)">Review</button>
					<a *ngIf="app.attachmentUrl" [href]="app.attachmentUrl" target="_blank" class="btn btn-sm btn-outline-secondary mt-2">Attachment</a>
				</td>
			</tr>
		</tbody>
	</table>

	<ng-template #reviewModal let-modal>
		<div class="card mt-3">
			<div class="card-body" style="max-height: 80vh; overflow-y: auto;">
				<h5 class="card-title">Review Application: {{ selectedApp?.fullName || selectedApp?.name }}</h5>

				<!-- Full Applicant Details Section -->
				<div class="alert alert-info mb-4">
					<h6>Applicant Details</h6>
					<div class="row">
						<div class="col-md-6">
							<p><strong>Full Name:</strong> {{ selectedApp?.fullName }}</p>
							<p><strong>Email:</strong> {{ selectedApp?.email }}</p>
                            <p><strong>Phone Number:</strong> {{ selectedApp?.phone }}</p>
							<p><strong>City:</strong> {{ selectedApp?.city }}</p>
							<p><strong>Date of Birth:</strong> {{ selectedApp?.dateOfBirth }}</p>
						</div>
						<div class="col-md-6">
							<p><strong>Education:</strong> {{ selectedApp?.education }}</p>
							<p><strong>Field of Study:</strong> {{ selectedApp?.fieldOfStudy }}</p>
							<p><strong>Technical Experience:</strong> {{ selectedApp?.technicalExperience }}</p>
							<p><strong>Track Interest:</strong> {{ selectedApp?.trackInterest }}</p>
						</div>
					</div>
					<hr>
					<div class="row">
						<div class="col-md-6">
							<p><strong>Employment Status:</strong> {{ selectedApp?.employmentStatus }}</p>
							<p><strong>Why are you interested in Mechanical or Electrical Engineering?:</strong> {{ selectedApp?.whyInterested }}</p>
							<p><strong>What problem in your community would you like to solve using engineering skills?:</strong> {{ selectedApp?.problemSolve }}</p>
						</div>
						<div class="col-md-6">
							<p><strong>Full Commitment Available:</strong> {{ selectedApp?.fullCommitment }}</p>
							<p><strong>What challenges might prevent you from completing this program? :</strong> {{ selectedApp?.challenges }}</p>
							<p><strong>How do you plan to overcome these challenges?:</strong> {{ selectedApp?.overcomeChallenges }}</p>
						</div>
					</div>
					<hr>
					<div class="row">
						<div class="col-md-6">
							<p><strong>Willing to be Disciplined:</strong> {{ selectedApp?.disciplineWilling }}</p>
							<p><strong>Why Select You:</strong> {{ selectedApp?.whySelect }}</p>
						</div>
						<div class="col-md-6">
							<p><strong>Commitment Agreement:</strong> {{ selectedApp?.commitmentAgreement }}</p>
							<p><strong>Submitted:</strong> {{ selectedApp && selectedApp.createdAt?.toDate ? (selectedApp.createdAt.toDate() | date:'medium') : (selectedApp?.createdAt | date:'medium') }}</p>
						</div>
					</div>
				</div>

				<!-- Admin Review Form Section -->
				<h6 class="mt-4">Admin Review</h6>

				<div class="mb-3">
					<label for="reason" class="form-label">Reason / Notes</label>
					<textarea id="reason" class="form-control" [(ngModel)]="reviewReason" name="reason" rows="3"></textarea>
				</div>

				<div class="mb-3">
					<label for="attachment" class="form-label">Attach screening document (optional)</label>
					<input type="file" id="attachment" (change)="onFileChange($event)" class="form-control" />
				</div>

				<div class="d-flex gap-2 flex-wrap">
					<!-- <button class="btn btn-success" (click)="submitReview('accepted')">Accept</button> -->
					<!-- <button class="btn btn-danger" (click)="submitReview('rejected')">Reject</button> -->
                    <button 
                    class="btn btn-success"
                    [disabled]="loadingStatus !== null"
                    (click)="submitReview('accepted')">
                    <span *ngIf="loadingStatus === 'accepted'"
                            class="spinner-border spinner-border-sm me-2">
                    </span>
                    Accept
                    </button>

                    <button 
                    class="btn btn-danger"
                    [disabled]="loadingStatus !== null"
                    (click)="submitReview('rejected')">
                    <span *ngIf="loadingStatus === 'rejected'"
                            class="spinner-border spinner-border-sm me-2">
                    </span>
                    Reject
                    </button>
                    <button class="btn btn-outline-secondary" (click)="viewApplicantResponses()">View Applicant Responses</button>
                    <button class="btn btn-secondary" (click)="modal.dismiss('cancel')">Cancel</button>
				</div>
			</div>
		</div>
	</ng-template>

	<ng-template #responsesModal let-modal>
		<div class="card mt-3">
			<div class="card-body">
				<h5 class="card-title">Applicant Responses: {{ selectedApp?.fullName || selectedApp?.name }}</h5>
				<table class="table table-sm">
					<tbody *ngIf="selectedApp">
						<tr *ngFor="let k of responseKeys()">
							<th style="width:30%">{{ k }}</th>
							<td>{{ $any(selectedApp)[k] }}</td>
						</tr>
					</tbody>
				</table>
				<div class="text-end">
					<button class="btn btn-secondary" (click)="modal.close()">Close</button>
				</div>
			</div>
		</div>
	</ng-template>
</div>
